module.exports = __webpack_public_path__ + "img/Yellow_Mixed.6505d3ba.png";